import { jsx as i } from "react/jsx-runtime";
var s = /* @__PURE__ */ ((e) => (e.Arial = "Arial, Helvetica, sans-serif", e.ArialBlack = "Arial Black, Gadget, sans-serif", e.Lucida = "Lucida sans unicode,lucida grande,sans-serif", e.Verdana = "verdana,geneva,sans-serif", e.Tahoma = "tahoma,geneva,sans-serif", e.TrebuchetMS = "trebuchet ms,helvetica,sans-serif", e.TimesNewRoman = "times new roman,times,serif", e.Georgia = "georgia, serif", e.Garamond = "garamond, serif", e.CourierNew = "courier new,courier,monospace", e.BrushScriptMT = "brush script mt, cursive", e.Helvetica = "Helvetica, Arial, sans-serif", e.ComicSansMS = "Comic Sans MS, sans-serif", e.Impact = "Impact, Charcoal, sans-serif", e))(s || {});
const r = (e) => e.split(",")[0].toLowerCase().replace(/["']/g, "").replace(/,/g, "_"), c = (e) => {
  switch (r(e)) {
    case r(
      "Arial, Helvetica, sans-serif"
      /* Arial */
    ):
      return "Arial";
    case r(
      "Arial Black, Gadget, sans-serif"
      /* ArialBlack */
    ):
      return "Arial Black";
    case r(
      "Lucida sans unicode,lucida grande,sans-serif"
      /* Lucida */
    ):
      return "Lucida";
    case r(
      "verdana,geneva,sans-serif"
      /* Verdana */
    ):
      return "Verdana";
    case r(
      "tahoma,geneva,sans-serif"
      /* Tahoma */
    ):
      return "Tahoma";
    case r(
      "trebuchet ms,helvetica,sans-serif"
      /* TrebuchetMS */
    ):
      return "Trebuchet MS";
    case r(
      "times new roman,times,serif"
      /* TimesNewRoman */
    ):
      return "Times New Roman";
    case r(
      "georgia, serif"
      /* Georgia */
    ):
      return "Georgia";
    case r(
      "garamond, serif"
      /* Garamond */
    ):
      return "Garamond";
    case r(
      "courier new,courier,monospace"
      /* CourierNew */
    ):
      return "Courier New";
    case r(
      "brush script mt, cursive"
      /* BrushScriptMT */
    ):
      return "Brush Script MT";
    case r(
      "Helvetica, Arial, sans-serif"
      /* Helvetica */
    ):
      return "Helvetica";
    case r(
      "Comic Sans MS, sans-serif"
      /* ComicSansMS */
    ):
      return "Comic Sans MS";
    case r(
      "Impact, Charcoal, sans-serif"
      /* Impact */
    ):
      return "Impact";
    default:
      return e;
  }
}, n = () => Object.values(s).map((e) => {
  const a = c(e);
  return {
    id: r(e),
    fontFamilyValue: e,
    caption: a,
    customCaption: /* @__PURE__ */ i("div", { style: { fontFamily: e }, children: a })
  };
});
export {
  s as FontFamilyEnum,
  r as getFontFamilyCode,
  c as getFontFamilyLabel,
  n as getFontFamilyOptionsData
};
